import { Types } from '@grandvisionhq/graphql';

const mapInsuranceLineItem = ({ sku , quantity , typeDetails  })=>({
        sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: Types.LineItemType.INSURANCE,
        typeDetails
    })
;

export { mapInsuranceLineItem };
//# sourceMappingURL=insurance.js.map
